/***************************************************************
	*
	HELPERS (REUSABLE)
	*
***************************************************************/

export function domReady(fn) {
	if ( document.readyState !== 'loading' ) {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

export function pageReady(fn) {
	if ( document.readyState === 'complete' ) {
		fn();
	} else {
		window.addEventListener('load', fn, { once: true });
	}
}

// Debounce function to prevent multiple rapid calls
export function debounce(func, wait) {
	let timeout;
	return function(...args) {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(context, args), wait);
	};
}
